/**
 * Sit down, lemme learn you some' bout whatsnew hybrid yall
 *
 * this wrapper function will render carousel on breakpoints >= tabletPortrait
 * and render gridview on mobile device breakpoints
 *
 * (specifically being used for whatsnew, thus the naming)
 *
 * eg.
 *
 * import whatsnewComponent from "components/whatsnewHybrid";
 *
 * whatsnewComponent({
 *     carouse: {
 *         parentContainer: $('#carousel-selector-here'),
 *         options: {
 *             endPoint: '...',
 *             params: {
 *                 slug: '...',
 *                 sectionId: '...'
 *             }
 *         }
 *     },
 *
 *     grid: {
 *         parentContainer: $('#grid-selector-here'),
 *         options: {
 *             endPoint: '...',
 *             params: {
 *                 slug: '...',
 *                 sectionId: '...'
 *             }
 *         }
 *     }
 * })
 *
 */

import landscapeCarousel from 'components/landscapeCarousel';
import gridView from 'components/gridView';
import Breakpoints from 'helpers/breakpoints';

export default function (customOptions = {}) {
    let b = new Breakpoints();
    let shouldRenderGrid = b.getMax('mobileLandscape') >= b.getMax(b.getCurrentBreakpointName());

    let gridWrapper = customOptions.grid.parentContainer
        ? customOptions.grid.parentContainer
        : $('#whatsnew-grid');
    let carouselWrapper = customOptions.carousel.parentContainer
        ? customOptions.carousel.parentContainer
        : $('#whatsnew-carousel');

    if (shouldRenderGrid) {
        // remove carousel from DOM
        carouselWrapper.closest('.js-le-carousel').remove();

        // invoke the grid
        let gridOptions = customOptions.grid.options;

        gridView({
            useTemplate: 'whatsNewTpl',
            parentContainer: gridWrapper,
            options: gridOptions
        });
    } else {
        // remove grid from DOM
        gridWrapper.remove();

        // invoke the carousel
        let carouselOptions = customOptions.carousel.options;

        landscapeCarousel({
            parentContainer: carouselWrapper,
            options: carouselOptions
        });
    }
}
